import styled from 'styled-components';
import { SYS_BREAKPOINT_MD, SYS_BREAKPOINT_LG, SYS_BREAKPOINT_XL, SYS_BREAKPOINT_2_XL, SYS_SPACE_FIXED_450, SYS_SPACE_FIXED_600, SYS_SPACE_RELATIVE_6_XL, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_300, SYS_SPACE_FIXED_400, } from '@oneaudi/unified-web-common';
import { dynamicStylingHelper } from '../../utils/AlphaHelper';
import { SYS_SPACE_RELATIVE_3_XL } from '@oneaudi/unified-web-alpha-common';
export const RangeFilterContainer = styled.div `
  width: 100%;
  margin-bottom: ${(props) => props.isPlpQuickFilters
    ? SYS_SPACE_FIXED_600
    : dynamicStylingHelper(SYS_SPACE_FIXED_450, SYS_SPACE_RELATIVE_3_XL)};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    width: calc(50% - 18px);
    margin-bottom: ${(props) => props.isPlpQuickFilters
    ? SYS_SPACE_RELATIVE_6_XL
    : dynamicStylingHelper(SYS_SPACE_FIXED_450, SYS_SPACE_RELATIVE_3_XL)};
  }
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    margin-bottom: ${(props) => props.isPlpQuickFilters
    ? '48px'
    : dynamicStylingHelper(SYS_SPACE_FIXED_300, SYS_SPACE_RELATIVE_3_XL)};
    width: ${(props) => (props.layoutWidth === '50' ? 'calc(50% - 20px)' : '100%')};
  }
  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    margin-bottom: ${(props) => props.isPlpQuickFilters
    ? '48px'
    : dynamicStylingHelper(SYS_SPACE_FIXED_300, SYS_SPACE_RELATIVE_3_XL)};
    width: ${(props) => (props.layoutWidth === '50' ? 'calc(50% - 26px)' : '100%')};
  }
  @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
    margin-bottom: ${(props) => props.isPlpQuickFilters
    ? '48px'
    : dynamicStylingHelper(SYS_SPACE_FIXED_400, SYS_SPACE_RELATIVE_3_XL)};
    width: ${(props) => (props.layoutWidth === '50' ? 'calc(50% - 34px)' : '100%')};
  }
`;
export const OptionsContainer = styled.div `
  display: flex;
  align-items: end;
  margin-bottom: ${(props) => props.isPlpQuickFilters ? SYS_SPACE_FIXED_300 : dynamicStylingHelper(SYS_SPACE_FIXED_300, '0')};

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    width: ${(props) => (props.layoutWidth === '50/100' ? 'calc(50% - 20px)' : '100%')};
  }
  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    width: ${(props) => (props.layoutWidth === '50/100' ? 'calc(50% - 26px)' : '100%')};
  }
  @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
    width: ${(props) => (props.layoutWidth === '50/100' ? 'calc(50% - 34px)' : '100%')};
  }
`;
export const StyledHeadingContainer = styled.div `
  display: flex;
  align-items: center;
  margin-block-end: ${(props) => props.isPlpQuickFilters ? 'var(--spacing-relative-sm)' : 'var(--spacing-relative-lg)'};

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    width: ${(props) => (props.layoutWidth === '50/100' ? 'calc(50% - 20px)' : '100%')};
  }
  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    width: ${(props) => (props.layoutWidth === '50/100' ? 'calc(50% - 26px)' : '100%')};
  }
  @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
    width: ${(props) => (props.layoutWidth === '50/100' ? 'calc(50% - 34px)' : '100%')};
  }
`;
export const Option = styled.div `
  flex: 1 1 0px;
`;
export const Spacing = styled.div `
  width: ${(props) => props.isPlpQuickFilters ? SYS_SPACE_FIXED_200 : SYS_SPACE_FIXED_150};
`;
